const getPageProperties = () => {
  return {
    locale: document.body.getAttribute('data-locale'),
    language: document.body.getAttribute('data-language'),
    country: document.body.getAttribute('data-country'),
    hostname: document.body.getAttribute('data-spree-hostname') || window.location.origin,
    environment: document.body.getAttribute('data-environment'),
    isCustomerServiceApp: document.body.classList.contains('customer-service-app'),
    isCartPage: document.body.id === 'cart',
    isSafari: /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent),
    scrollbarWidth: window.innerWidth - document.documentElement.clientWidth,
  }
}

const setPageProperties = () => {
  On.Store.commit('page/setState', getPageProperties())
}

export default {
  namespaced: true,
  state: {
    locale: '',
    language: '',
    country: '',
    hostname: '',
    environment: '',
    isCustomerServiceApp: false,
    isCartPage: false,
    scrollbarWidth: 0,
    isChatOnline: false,
  },

  getters: {
    locale: state => state.locale,
    dateLocale: state => state.locale.substring(0, 3) + state.locale.substring(3).toUpperCase(),
    language: state => state.language,
    country: state => state.country,
    currency: state => state.currency,
    hostname: state => state.hostname,
    environment: state => state.environment,
    isCustomerServiceApp: state => state.isCustomerServiceApp,
    isCartPage: state => state.isCartPage,
    isSafari: state => state.isSafari,
    scrollbarWidth: state => state.scrollbarWidth,
    homepageUrl: state => state.hostname + (state.locale !== null ? '/' + state.locale : ''),
    isChatOnline: state => state.isChatOnline,
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },
    setChatOnlineState(state, payload) {
      state.isChatOnline = payload
    },
  },

  actions: {
    setChatOnlineState({ commit }, payload) {
      commit('setChatOnlineState', payload)
    },
  },
}

// Page properties have to be set *before* any other DOMContentLoaded handlers run since some
// of them rely on the page store (e.g. to build GraphQL clients). This is why this complicated
// scheduling is in place below (readystatechange fires before DOMContentLoaded).
document.addEventListener('readystatechange', function() {
  if (document.readyState !== 'loading') {
    setPageProperties()
  }
})
if (window.ON_DOCUMENT_READY) window.ON_DOCUMENT_READY(setPageProperties)
